import React, { useState } from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import '../App.css';

const links = [
  { id: 'inicio', label: 'Início' },
  { id: 'quem-sou-eu', label: 'Quem sou eu' },
  { id: 'formacao-e-atuacao', label: 'Formação e Atuação' },
  { id: 'atendimento', label: 'Atendimento' },
  { id: 'publicacoes', label: 'Publicações' },
  { id: 'contato', label: 'Contato' },
];

function CustomNavbar({ activeSection, onNavigate }) {
  const [expanded, setExpanded] = useState(false);

  const handleNav = (event, sectionId) => {
    event.preventDefault();
    setExpanded(false);

    window.setTimeout(() => {
      onNavigate(sectionId);
    }, expanded ? 320 : 0);
  };

  return (
    <Navbar expand="lg" className="site-header" expanded={expanded}>
  <div className="navbar-inner">
    <Navbar.Toggle
      aria-controls="basic-navbar-nav"
      className="navbar-toggler button-hamburguer"
      onClick={() => setExpanded(!expanded)}
    />

    <Navbar.Collapse id="basic-navbar-nav" className="navbar-menu">
      <Nav className="nav-links">
        {links.map((link) => (
          <Nav.Link
            key={link.id}
            href={`#${link.id}`}
            className={`nav-item-link ${activeSection === link.id ? 'ativo' : ''}`}
            onClick={(event) => handleNav(event, link.id)}
          >
            {link.label}
          </Nav.Link>
        ))}
      </Nav>
    </Navbar.Collapse>
  </div>
</Navbar>
  );
}

export default CustomNavbar;